import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import * as dat from 'lil-gui'
//import { RectAreaLightHelper }  from 'three/examples/jsm/helpers/RectAreaLightHelper.js'




/**
 * Base
 */
// Debug
// const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')


// Scene
const scene = new THREE.Scene()

// Fog 
const fog = new THREE.Fog('#262837', 1, 15)
scene.fog = fog

// const sun = new THREE.DirectionalLight('white',1 )
// sun.position.set( 3,3,-6)
// scene.add(sun)
/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const doorColorTexture = textureLoader.load('/textures/door/color.jpg')
const doorAlphaTexture = textureLoader.load('/textures/door/alpha.jpg')
const doorAmbientOcclusionTexture = textureLoader.load('/textures/door/ambientOcclusion.jpg')
const doorHeightTexture = textureLoader.load('/textures/door/height.jpg')
const doorNormalTexture = textureLoader.load('/textures/door/normal.jpg')
const doorMetalnessTexture = textureLoader.load('/textures/door/metalness.jpg')
const doorRoughnessTexture = textureLoader.load('/textures/door/roughness.jpg')

const bricksColorTexture = textureLoader.load('/textures/bricks/color.jpg')
const bricksAmbientOcclusionTexture = textureLoader.load('/textures/bricks/ambientOcclusion.jpg')
const bricksNormalTexture = textureLoader.load('/textures/bricks/normal.jpg')
const bricksRoughnessTexture = textureLoader.load('/textures/bricks/roughness.jpg')

const grassColorTexture = textureLoader.load('/textures/grass/color.jpg')
const grassAmbientOcclusionTexture = textureLoader.load('/textures/grass/ambientOcclusion.jpg')
const grassNormalTexture = textureLoader.load('/textures/grass/normal.jpg')
const grassRoughnessTexture = textureLoader.load('/textures/grass/roughness.jpg')

grassColorTexture.repeat.set(8, 8)
grassAmbientOcclusionTexture.repeat.set(8, 8)
grassNormalTexture.repeat.set(8, 8)
grassRoughnessTexture.repeat.set(8, 8)

grassColorTexture.wrapS = THREE.RepeatWrapping
grassAmbientOcclusionTexture.wrapS = THREE.RepeatWrapping
grassNormalTexture.wrapS = THREE.RepeatWrapping
grassRoughnessTexture.wrapS = THREE.RepeatWrapping

grassColorTexture.wrapT = THREE.RepeatWrapping
grassAmbientOcclusionTexture.wrapT = THREE.RepeatWrapping
grassNormalTexture.wrapT = THREE.RepeatWrapping
grassRoughnessTexture.wrapT = THREE.RepeatWrapping

/**
 * House
 */
const house = new THREE.Group()
scene.add(house)

// Walls
const walls = new THREE.Mesh(
    new THREE.BoxGeometry(4, 2.5, 4),
    new THREE.MeshStandardMaterial({
        map: bricksColorTexture,
        aoMap: bricksAmbientOcclusionTexture,
        normalMap: bricksNormalTexture,
        roughnessMap: bricksRoughnessTexture
    })
)
walls.geometry.setAttribute('uv', new THREE.Float32BufferAttribute(walls.geometry.attributes.uv.array, 2))
walls.position.y = (2.5 / 2) + 0.01
house.add(walls)

// Roof
const roof = new THREE.Mesh(
    new THREE.ConeGeometry(3.2, 2, 4),
    new THREE.MeshStandardMaterial({color: '#b35f45'})
)
roof.position.y = 2.5 + 1
roof.rotation.y = Math.PI / 4

house.add(roof)

//Door
const door = new THREE.Mesh(
    new THREE.PlaneGeometry(2, 2, 100, 100),
    new THREE.MeshStandardMaterial({
        map: doorColorTexture,
        transparent: true,
        alphaMap: doorAlphaTexture,
        aoMap: doorAmbientOcclusionTexture,
        displacementMap: doorHeightTexture,
        displacementScale: 0.1,
        normalMap: doorNormalTexture,
        metalnessMap: doorMetalnessTexture,
        roughnessMap: doorRoughnessTexture

    })
)
door.geometry.setAttribute('uv', new THREE.Float32BufferAttribute(door.geometry.attributes.uv.array, 2))
door.position.y  = 1.5/2 + 0.2
door.position.z = 4/2
house.add(door)

//Bushes
const bushGeometry = new THREE.SphereGeometry(1,16,16)
const bushMaterial = new THREE.MeshStandardMaterial({color: '#89c854'})

const bush1 = new THREE.Mesh(bushGeometry, bushMaterial)
bush1.position.set(1.1, 0.2, 2.5)
bush1.scale.set(0.5, 0.5, 0.5)

const bush2 = new THREE.Mesh(bushGeometry, bushMaterial)
bush2.position.set(-2.3, 0.2, 2.5)
bush2.scale.set(0.6, 0.9, 0.5)

const bush3 = new THREE.Mesh(bushGeometry, bushMaterial)
bush3.position.set(1.8, 0.2, 2.5)
bush3.scale.set(0.2, 0.3, 0.2)
house.add(bush1, bush2, bush3)

const bush4 = new THREE.Mesh(bushGeometry, bushMaterial)
bush4.position.set(1.65, 0.1, 2.9)
bush4.scale.set(0.2, 0.2, 0.2)
house.add(bush1, bush2, bush3, bush4)


// BackDoor
const backDoorGroup = new THREE.Group()

const backDoor = new THREE.Mesh(
    new THREE.PlaneGeometry(1, 1.5),
    new THREE.MeshBasicMaterial({color: 'black'})
)
backDoor.material.side = THREE.BackSide
backDoorGroup.position.y  = 1.5/2
backDoorGroup.position.z = -4/2 - 0.01
backDoorGroup.add(backDoor)

const spotLight = new THREE.SpotLight( '#2E8B57', 10, 10, 0.3);
spotLight.target = backDoor
spotLight.position.y = spotLight.position.y - 0.7
spotLight.position.z = spotLight.position.z +2.5


backDoorGroup.add(spotLight)
// const spotLightHelper = new THREE.SpotLightHelper( spotLight );
// scene.add( spotLightHelper );

house.add(backDoorGroup)

// RectAreaLight on, backDoor house
const width = 4;
const height = 0.5;
const intensity = 3;
const rectLight = new THREE.RectAreaLight( '#2E8B57', intensity,  width, height );
rectLight.position.set( 0, 2.5, -2.01 );
rectLight.lookAt(0,0,0)

house.add( rectLight )
// const rectLightHelper = new RectAreaLightHelper( rectLight );
// rectLight.add( rectLightHelper );


// Graves
const graves = new THREE.Group()
scene.add(graves)

const graveGeometry = new THREE.BoxGeometry(0.6, 0.8, 0.2)
const graveMaterial = new THREE.MeshStandardMaterial({color: '1b2b6b1'})

for (let i = 0; i < 50; i++) {
    const angle = Math.random() * Math.PI * 2
    const radius = 4.5 + Math.random() * 5
    const x = Math.sin(angle) * radius
    const z = Math.cos(angle) * radius
    const grave = new THREE.Mesh(graveGeometry, graveMaterial)
    grave.position.set(x, 0.8/2, z)
    grave.rotation.y = (Math.random() - 0.5) * 0.7
    grave.rotation.z = (Math.random() - 0.5) * 0.3
    graves.add(grave)
    grave.castShadow = true
}


// Floor
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(20, 20),
    new THREE.MeshStandardMaterial({
        map: grassColorTexture,
        aoMap: grassAmbientOcclusionTexture,
        normalMap: grassNormalTexture,
        roughnessMap: grassRoughnessTexture,
        side: THREE.DoubleSide }
    )
)
floor.geometry.setAttribute('uv', new THREE.Float32BufferAttribute(floor.geometry.attributes.uv.array, 2))
floor.rotation.x = - Math.PI * 0.5
floor.position.y = 0
scene.add(floor)

/**
 * Lights
 */
// Ambient light
const ambientLight = new THREE.AmbientLight('#b9d5ff', 0.12)
// gui.add(ambientLight, 'intensity').min(0).max(1).step(0.001)
scene.add(ambientLight)

// Directional light
const moonLight = new THREE.DirectionalLight('#ffffff', 0.12)
moonLight.position.set(4, 1, - 2)
// gui.add(moonLight, 'intensity').min(0).max(1).step(0.001)
// gui.add(moonLight.position, 'x').min(- 5).max(5).step(0.001)
// gui.add(moonLight.position, 'y').min(- 5).max(5).step(0.001)
// gui.add(moonLight.position, 'z').min(- 5).max(5).step(0.001)
scene.add(moonLight)

// Door light
const doorLight = new THREE.PointLight('#ff7d46', 1, 7)
doorLight.position.set(0, 2.2, 2.7)
house.add(doorLight)

/**
 * Croix
 */
const croix = new THREE.Group()
scene.add(croix)
const cube1 = new THREE.Mesh(
    new THREE.BoxGeometry(1, 0.3, 0.5),
    new THREE.MeshStandardMaterial()
)
const cube2 = new THREE.Mesh(
    new THREE.BoxGeometry(0.4, 1.5, 0.5),
    new THREE.MeshStandardMaterial()
)

croix.add(cube1, cube2)
croix.position.set(5, 1.5/2 - 0.1, 4)

croix.rotation.z = 0.2

const croixLight = new THREE.PointLight('#green', 0.5, 3)
croixLight.position.set(0, 0, 0.7)
croix.add(croixLight)



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 4
camera.position.y = 4
camera.position.z = 10
// Camera position to see the back of the house
// camera.position.x = 0.9
// camera.position.y = 5.28
// camera.position.z = -13.69
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor('#262837')

/**
 * Shadows
 */
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
moonLight.castShadow = true
doorLight.castShadow = true
floor.receiveShadow = true

walls.castShadow = true
bush1.castShadow = true
bush2.castShadow = true
bush3.castShadow = true
bush4.castShadow = true


/**
 * Ghosts
 */
const ghost1 = new THREE.PointLight('#262837', 2, 3)
// const pointLightHelper = new THREE.PointLightHelper( ghost1, 0.5 );
// scene.add( pointLightHelper );
scene.add(ghost1)

function animateGhosts(elapsedTime) {
    const ghost1Angle = elapsedTime / 3
    ghost1.position.x = Math.cos(ghost1Angle) * 5
    ghost1.position.z = Math.sin(ghost1Angle) * 5
    ghost1.position.y = Math.sin(ghost1Angle * 4)
}

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    animateGhosts(elapsedTime)
    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()